import { connect } from "react-redux";

import { FullFormState } from "../../../../Engine/Core/Store/FullFormState";
import { CandyDispatch } from "../../../../Engine/Core/Store/CandyReduxTypes";
import { setToLocalStorage } from "../../../../Engine/Core/Store/LocalStorageUtils";
import { CaptionsViewMode, captionsViewModeKey, HintsViewMode, hintsViewModeKey } from "../ViewModes";

import { ViewModeSelectButton } from "./ViewModeSelectButton";

const mapState = (state: FullFormState) => ({
    captionsViewMode: state.viewModes.captions,
    hintsViewMode: state.viewModes.hints,
});

const mapDispatch = (dispatch: CandyDispatch) => ({
    onChangeCaptionsViewMode: (next: CaptionsViewMode) => {
        setToLocalStorage<CaptionsViewMode>(captionsViewModeKey, next);
        dispatch({
            type: "UpdateViewModes",
            payload: {
                captions: next,
            },
        });
    },
    onChangeHintsViewMode: (next: HintsViewMode) => {
        setToLocalStorage<HintsViewMode>(hintsViewModeKey, next);
        dispatch({ type: "UpdateViewModes", payload: { hints: next } });
    },
});

export const ViewModeSelectButtonContainer = connect(mapState, mapDispatch)(ViewModeSelectButton);
